import React, { useEffect, useState } from "react";
import { useLoader } from "../context/LoaderContext";
import { ISubHeadingData, ISurgicalData } from "../exports/interfaces";
import { fetchContentsBySubHeading } from "../api/SurgicalDomainApi";
import { dynamicFailed } from "../hooks/useToast";
import DynamicSurgicalBanner from "../components/surgicaldomains/DynamicSurgicalBanner";
import DynamicSurgicalDescription from "../components/surgicaldomains/DynamicSurgicalDescription";

const SurgicalDomainPages = (props: { data: ISubHeadingData }) => {
  const { setLoading } = useLoader();
  const [surgicalDomainData, setSurgicalDomainData] = useState<ISurgicalData[]>(
    []
  );
  useEffect(() => {
    setLoading(true);
    Promise.all([
      fetchContentsBySubHeading(props?.data?.attributes?.Sub_Heading_Name),
    ])
      .then(([surgicalDomainData]) => {
        setSurgicalDomainData(surgicalDomainData);
        setTimeout(() => {
          setLoading(false);
        }, 1000);
      })
      .catch(() => {
        setTimeout(() => {
          setLoading(false);
        }, 1000);
        dynamicFailed("Server Error");
      });
  }, [props?.data?.attributes?.Sub_Heading_Name, setLoading]);
  return (
    <>
      <DynamicSurgicalBanner
        bannerData={props?.data}
        page={props?.data?.attributes?.Sub_Heading_Name}
      />
        <DynamicSurgicalDescription descriptionData={surgicalDomainData} subHeadingData={props?.data}/>
      {/* <SurgicalDomainsDescription descriptionData={rhinoplastyData} consentLetters={consentLetters} surgicalName='Rhinoplasty' /> */}
    </>
  );
};

export default SurgicalDomainPages;
